var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "137px",
    height: "98px",
    viewBox: "0 0 137 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "t0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.5-Crea-nuova-richiesta---step-3-video-Copy",
    transform: "translate(-1100.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1101.000000, 490.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.750364,86 L4.24963604,86 C1.90257427,86 0,84.1243422 0,81.8106777 L0,4.18932232 C0,1.8756578 1.90257427,0 4.24963604,0 L115.750364,0 C118.097426,0 120,1.8756578 120,4.18932232 L120,81.8106777 C120,84.1243422 118.097426,86 115.750364,86",
    id: "Fill-1",
    stroke: "#C9D9E8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.351744186,
    y1: 95.5,
    x2: 120.648256,
    y2: 95.5,
    id: "Line",
    stroke: "#C9D9E8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.883787,80 L10.1162972,80 C7.84292483,80 6,78.263037 6,76.1204556 L6,9.8796242 C6,7.73696297 7.84292483,6 10.1162972,6 L109.883787,6 C112.15716,6 114,7.73696297 114,9.8796242 L114,76.1204556 C114,78.263037 112.15716,80 109.883787,80",
    id: "Fill-3",
    fill: "#B9E6F6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(41.625000, 21.250088)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7249066,24.9374405 C23.3706794,24.9374405 22.2385868,26.2499374 18.3749562,26.2499374 C14.5113256,26.2499374 13.3874841,24.9374405 11.0250058,24.9374405 C4.9382855,24.9374405 0,29.875726 0,35.9624463 L0,38.0624093 C0,40.2362322 1.76366767,41.9998999 3.93749061,41.9998999 L32.8124218,41.9998999 C34.9862447,41.9998999 36.7499124,40.2362322 36.7499124,38.0624093 L36.7499124,35.9624463 C36.7499124,29.875726 31.8116269,24.9374405 25.7249066,24.9374405 Z M32.8124218,38.0624093 L3.93749061,38.0624093 L3.93749061,35.9624463 C3.93749061,32.05772 7.1202795,28.8749312 11.0250058,28.8749312 C12.2226271,28.8749312 14.1667791,30.187428 18.3749562,30.187428 C22.6159777,30.187428 24.5191142,28.8749312 25.7249066,28.8749312 C29.6296329,28.8749312 32.8124218,32.05772 32.8124218,35.9624463 L32.8124218,38.0624093 Z M18.3749562,23.6249437 C24.896425,23.6249437 30.187428,18.3339407 30.187428,11.8124718 C30.187428,5.29100301 24.896425,0 18.3749562,0 C11.8534874,0 6.56248435,5.29100301 6.56248435,11.8124718 C6.56248435,18.3339407 11.8534874,23.6249437 18.3749562,23.6249437 Z M18.3749562,3.93749061 C22.714431,3.93749061 26.2499374,7.47299701 26.2499374,11.8124718 C26.2499374,16.1519467 22.714431,19.6874531 18.3749562,19.6874531 C14.0354814,19.6874531 10.499975,16.1519467 10.499975,11.8124718 C10.499975,7.47299701 14.0354814,3.93749061 18.3749562,3.93749061 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(12.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C9D9E8",
    x: 0,
    y: 0,
    width: 21,
    height: 25,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uF82D",
    transform: "translate(5.250000, 6.500025)",
    fill: "#F2F5F8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49998212,8.24998033 L6.95858631,8.24998033 C6.50972722,8.45698057 5.74427952,8.62497944 5.24998748,8.62497944 C4.75569545,8.62497944 3.99024775,8.45698057 3.54138865,8.24998033 L3,8.24998033 C1.34399094,8.24998033 0,9.59397127 0,11.2499803 C0,11.6639737 0.335997734,11.9999714 0.749998212,11.9999714 L9.74997675,11.9999714 C10.1639772,11.9999714 10.499975,11.6639737 10.499975,11.2499803 C10.499975,9.59397127 9.15598403,8.24998033 7.49998212,8.24998033 Z M1.12499732,5.24998748 C1.33199756,5.24998748 1.49999642,5.08198862 1.49999642,4.87498838 L1.49999642,4.49998927 C1.49999642,2.43234436 3.18234257,0.749998212 5.24998748,0.749998212 C7.31763239,0.749998212 8.99997854,2.43234436 8.99997854,4.49998927 L8.99997854,4.87498838 C8.99881125,5.90882228 8.15881691,6.74881661 7.12498301,6.74998391 L6.3749848,6.74998391 C6.3749848,6.33598343 6.03898707,5.99998569 5.62498659,5.99998569 L4.87498838,5.99998569 C4.4609879,5.99998569 4.12499017,6.33598343 4.12499017,6.74998391 C4.12499017,7.16398438 4.4609879,7.49998212 4.87498838,7.49998212 L7.12498301,7.49998212 C8.57217652,7.49817396 9.74816859,6.32218189 9.74997675,4.87498838 L9.74997675,4.49998927 C9.74997675,2.01866432 7.73131244,0 5.24998748,0 C2.76866253,0 0.749998212,2.01866432 0.749998212,4.49998927 L0.749998212,4.87498838 C0.749998212,5.08198862 0.917997079,5.24998748 1.12499732,5.24998748 Z M4.87498838,5.24998748 L5.62498659,5.24998748 C6.10289072,5.25010192 6.68470696,5.58609966 6.92365903,5.99998569 L7.12498301,5.99998569 C7.74534286,5.99934483 8.24933946,5.49534823 8.24998033,4.87498838 L8.24998033,4.49999642 C8.24998033,2.84398736 6.90598939,1.49999642 5.24999464,1.49999642 C3.59398557,1.49999642 2.24999464,2.84398736 2.24999464,4.49999642 C2.24999464,5.44732893 2.69764066,6.28123502 3.3831859,6.83130543 C3.38178973,6.80388545 3.37499195,6.77788454 3.37499195,6.74998391 C3.37588459,5.92289848 4.04790295,5.25088012 4.87498838,5.24998748 Z",
    id: "Shape"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(107.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#005075",
    cx: 14.5,
    cy: 14.5,
    r: 14.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(6.782328, 8.685831)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3600665,0.123544398 L5.11244985,9.37116105 L1.71455833,5.97326953 C1.54979813,5.80850933 1.28269367,5.80850933 1.11789914,5.97326953 L0.123570148,6.96759852 C-0.0411900492,7.13235871 -0.0411900492,7.39946318 0.123570148,7.56425771 L4.81413743,12.254825 C4.97886329,12.4195508 5.24596776,12.4195508 5.41076228,12.254825 L15.9510204,1.71453258 C16.1157806,1.54980671 16.1157806,1.28266792 15.9510204,1.11790772 L14.9566914,0.123544398 C14.7919312,-0.0411814661 14.5248267,-0.0411814661 14.3600665,0.123544398 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.2c5419daec09311f62051504e5e8081c.svg";
export { ForwardRef as ReactComponent };